import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import { PageHeader } from '../../components/ui/page-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { useDroitsStation } from '../../components/stations/StationPicker';
import WeeklyDeclaration from '../../components/stations/WeeklyDeclaration';
import ManagerStatement from '../../components/stations/ManagerStatement';
import NetworkImport from '../../components/stations/NetworkImport';

/**
 * Conformité et gérance (lot 034) : déclaration hebdomadaire des stocks (PDF et
 * Excel), relevé mensuel du gérant (montants : droit « montants visibles »),
 * reprise d'un réseau par Excel (administrateur). Chaque onglet n'apparaît que
 * si les droits le permettent ; le serveur contrôle les mêmes droits.
 */

const StationCompliancePage = () => {
  const { canSeeMoney } = useAuth();
  const droits = useDroitsStation();
  const [searchParams, setSearchParams] = useSearchParams();

  const onglets = useMemo(
    () =>
      [
        ['declaration', 'Déclaration hebdomadaire', true],
        ['gerant', 'Relevé du gérant', Boolean(canSeeMoney)],
        ['reprise', 'Reprise du réseau', droits.estAdministrateur],
      ].filter(([, , visible]) => visible),
    [canSeeMoney, droits.estAdministrateur],
  );
  const demande = searchParams.get('onglet');
  const onglet = onglets.some(([cle]) => cle === demande) ? demande : 'declaration';
  const changer = (valeur) => {
    const suivants = new URLSearchParams(searchParams);
    suivants.set('onglet', valeur);
    setSearchParams(suivants, { replace: true });
  };

  return (
    <div className="mx-auto w-full max-w-page space-y-4 px-4 py-5 md:px-6 md:py-6 lg:px-8">
      <PageHeader
        eyebrow="Stations"
        title="Conformité"
        description="Déclaration hebdomadaire des stocks, relevé du gérant, reprise d’un réseau par Excel."
      />
      <Tabs value={onglet} onValueChange={changer}>
        <TabsList className="h-auto flex-wrap justify-start">
          {onglets.map(([cle, texte]) => (
            <TabsTrigger key={cle} value={cle}>
              {texte}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="declaration" className="mt-4">
          <WeeklyDeclaration />
        </TabsContent>
        <TabsContent value="gerant" className="mt-4">
          <ManagerStatement />
        </TabsContent>
        <TabsContent value="reprise" className="mt-4">
          <NetworkImport />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default StationCompliancePage;
